import $ from 'jquery';
export default class ReorderElements {
    static $element = $('.js__reorder-element');
    static init() {
        if (!this.$element.length) {
            return;
        }
        this.$element.each((index, element) => {
            const $element = $(element);
            const $elementBefore = $($element.data('after-element')).last();
            $element.insertAfter($elementBefore);
        });
    }
}
